import Form, { FormItemProps } from "@/shared/form/form";
import { SupportedLanguages } from "gql/graphql";
import { useLocalizedControl } from "../../model/localized-value-control-context";
import { useTranslations } from "use-intl";

type LocaleFormItemProps = FormItemProps & {
  locale: SupportedLanguages;
};

export function LocaleFormItem({ locale, ...rest }: LocaleFormItemProps) {
  const {
    currentLanguages,
    render,
    inputRef,
    formItemProps,
    languageToPlaceholder,
    languageToControlName,

    myLocaleRules,
  } = useLocalizedControl();

  const t = useTranslations("LocalizedValue");

  const mergedFormItemProps = { ...formItemProps, ...rest };

  const rules = mergedFormItemProps.rules ?? [];

  return (
    <Form.Item
      validateTrigger={["onChange", "onBlur"]}
      {...mergedFormItemProps}
      name={[
        ...(Array.isArray(formItemProps.name)
          ? formItemProps.name
          : [formItemProps.name]),
        languageToControlName(locale),
      ]}
      rules={
        locale === currentLanguages
          ? [...rules, ...(myLocaleRules ?? [])]
          : rules
      }
    >
      {render({
        placeholder: t(languageToPlaceholder(locale)),
        ref: locale === currentLanguages ? inputRef : undefined,
      })}
    </Form.Item>
  );
}
